module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.d4f38edf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-LightItalic.woff2
// module id = 534
// module chunks = 0